import './About.scss';

function About() {
  return (
    <section id="about" className="about">
      <div className="container about__layout">
        <div className="about__profile">
          <img src="/images/shop.jpg" alt="Cipher Works fabrication shop" />
        </div>
        <div className="about__copy">
          <span className="section-eyebrow">About</span>
          <h2 className="section-title">
            A Montreal workshop for projects that fall between DIY and factory scale
          </h2>
          <p>
            Cipher Works tackles the technical jobs that never quite fit the usual playbook. Short
            run tooling, precise fixtures, shielded cabling, and one off mechanisms all need both
            research and hands on fabrication.
          </p>
          <p>
            You work directly with the mechanical designer who scopes the problem, models the
            solution, and builds it under one roof. No handoffs, no corporate bloat. Just practical
            engineering that moves unusual projects forward.
          </p>
          <ul className="about__list">
            <li>CNC machining, sheet metal forming, and additive prototyping on site</li>
            <li>Reverse engineering from sketches, samples, or orphaned CAD</li>
            <li>Electronics benches for shielded cabling and test fixtures</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default About;
